import React, { useEffect, useRef } from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import PhasePlaceholder from "../../../Utils/Assets/Images/Phase2-Placeholder.png";

const HowItWorksSection = () => {
    const scrollRef = useRef(null);
    const thumbRef = useRef(null);

    useEffect(() => {
        const box = scrollRef.current;
        const thumb = thumbRef.current;

        if (!box || !thumb) return;

        const handleScroll = () => {
            const isMobile = window.innerWidth <= 768;

            if (isMobile) {
                const scrollLeft = box.scrollLeft;
                const scrollWidth = box.scrollWidth - box.clientWidth;
                const trackWidth = box.clientWidth - thumb.offsetWidth;

                const ratio = scrollLeft / scrollWidth;
                thumb.style.transform = `translateX(${trackWidth * ratio}px)`;
            } else {
                const scrollTop = box.scrollTop;
                const scrollHeight = box.scrollHeight - box.clientHeight;
                const trackHeight = box.clientHeight - thumb.offsetHeight;

                const ratio = scrollTop / scrollHeight;
                thumb.style.transform = `translateY(${trackHeight * ratio}px)`;
            }
        };

        box.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);

        return () => {
            box.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);

    return (
        <div className={styles.Container}>
            <MeetUsWrapper>
                <section className={styles.HowToSpendMvrCoinsSection}>
                    <div
                        className={styles.rightCard}
                        data-aos="fade-right"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <div className={styles.CardImage}>
                            <img
                                src={PhasePlaceholder}
                                alt="Phase2-Placeholder"
                            />
                        </div>
                    </div>

                    <div className={styles.leftCard}>
                        <p
                            className={styles.title}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            How It Works: Join & Host <br />
                            Events in MeetUsVRr
                        </p>

                        <div
                            className={styles.CardScrollWrapper}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.CardScroll} ref={scrollRef}>
                                <div className={styles.CardScrollContent}>
                                    <p
                                        className={
                                            styles.CardScrollContentTitle
                                        }
                                    >
                                        Step 1 - Create Your Event
                                    </p>
                                    <p
                                        className={
                                            styles.CardScrollContentDescription
                                        }
                                    >
                                        Explore products, services, or premium
                                        features like virtual rooms. Click on
                                        your desired option to view details.
                                    </p>
                                </div>
                                <div className={styles.CardScrollContent}>
                                    <p
                                        className={
                                            styles.CardScrollContentTitle
                                        }
                                    >
                                        Step 2 - Invite Your Friend
                                    </p>
                                    <p
                                        className={
                                            styles.CardScrollContentDescription
                                        }
                                    >
                                        For virtual features, click “Redeem
                                        Now.” For products or services, add them
                                        to your cart and proceed to checkout.
                                    </p>
                                </div>
                                <div className={styles.CardScrollContent}>
                                    <p
                                        className={
                                            styles.CardScrollContentTitle
                                        }
                                    >
                                        Step 3 - Join Meeting
                                    </p>
                                    <p
                                        className={
                                            styles.CardScrollContentDescription
                                        }
                                    >
                                        Review your selection, confirm the
                                        purchase, and start enjoying your
                                        unlocked item, feature, or experience!
                                    </p>
                                </div>
                                <div className={styles.CardScrollContent}>
                                    <p
                                        className={
                                            styles.CardScrollContentTitle
                                        }
                                    >
                                        Step 4 - Earn MVR for Every Guest Interaction!
                                    </p>
                                    <p
                                        className={
                                            styles.CardScrollContentDescription
                                        }
                                    >
                                        As guests engage with your event, you
                                        earn MVR coins automatically. The more
                                        interactions your event generates, the
                                        more rewards you collect to spend across
                                        MeetUsVR.
                                    </p>
                                </div>
                            </div>

                            <div className={styles.scrollIndicator}>
                                <span
                                    ref={thumbRef}
                                    className={styles.scrollThumb}
                                ></span>
                            </div>
                        </div>
                    </div>
                </section>
            </MeetUsWrapper>
        </div>
    );
};

export default HowItWorksSection;
